import { Modal } from "@/shared/ui/modal/Modal";
import { Pagination } from "@/shared";
import defptPhoto from "../../../../public/assets/images/defphoto.jpg";
import {
  FilterOption,
  FilterTable,
} from "@/widgets/filter/filter-table/FilterTable";

import styles from "./ModalTableList.module.scss";

type Props = {
  onClick: (value: any) => void;
  onClose: () => void;
  title: string;
  isOpen: boolean;
  totalCount: number;
  limit: number;
  page: number;
  changePage: (page: number) => void;
  itemList: { id: number; title: string; description: string; img: string }[];
  onCancelSearch: () => void;
  onSubminSearch: (values: Record<string, string>) => void;
  filterOptions: FilterOption[];
  disabledIds?: number[];
  emptySearch: boolean;
};

const ModalTableList = ({
  itemList,
  onClick,
  isOpen,
  onClose,
  title,
  changePage,
  limit,
  page,
  totalCount,
  onCancelSearch,
  onSubminSearch,
  filterOptions,
  disabledIds,
  emptySearch,
}: Props) => {
  const isDisabledItem = (itemId: number) => {
    if (!disabledIds || !disabledIds.length) return false;
    return disabledIds.includes(itemId);
  };

  return (
    <Modal
      active={isOpen}
      handleClose={onClose}
      classContaner={styles.container}
    >
      <header className={styles.headerTable}>
        <section className={styles.headerLeftSide}>
          <FilterTable
            classFilterForm={styles.classFilterForm}
            colorSvg="white"
            topPositionForm={42}
            labelSvg=" "
            onSubminSearch={onSubminSearch}
            onCancelSearch={onCancelSearch}
            filterOptions={filterOptions}
          />
          <h1 className={styles.modalTitle}>{title}</h1>
        </section>
        <button title="Закрыть" onClick={onClose} className={styles.modalClose}>
          x
        </button>
      </header>

      <>
      {emptySearch &&
      <div className={styles.emptySearch}>
      <div>В настоящее время данные отсутствуют</div>
      <button onClick={onCancelSearch} className={styles.emptyClearSearch}>Отменить поиск</button>
      </div>
    }
    </>

      <ul className={styles.tableList}>
        {itemList.length > 0 &&
          itemList.map((item) => (
            <li
              onClick={() => !isDisabledItem(item.id) && onClick(item)}
              key={item.id}
              className={isDisabledItem(item.id) ? `${styles.tableItem} ${styles.tableItemDisabled}` : styles.tableItem}
            >
              <img
                src={item.img ? item.img : defptPhoto}
                alt="Table images"
                className={styles.tableImage}
              />

              <div className={styles.bodyCard}>
                <h1 className={styles.tableItemTitle}>
                  {item.title ? item.title : "---"}
                </h1>
                {item.description && (
                  <p className={styles.tableItemDescription}>
                    {item.description ? item.description : "---"}
                  </p>
                )}
              </div>
              {!isDisabledItem(item.id) && (
                <button className={styles.tableItemBtn}>{"Выбрать"}</button>
              )}
            </li>
          ))}
      </ul>

      <footer className={styles.footer}>
        <p className={styles.footerTotal}>Всего: {totalCount}</p>
        {totalCount && limit && page && changePage && (
          <Pagination
            className={styles.pagination}
            totalCount={totalCount}
            countPerPage={limit}
            currentPage={page}
            clickNumber={(value) => changePage(value)}
            nextPage={() => changePage(page + 1)}
            prevPage={() => changePage(page - 1)}
          />
        )}
      </footer>
    </Modal>
  );
};

export { ModalTableList };
